import { gql } from '@apollo/client'

export const Query = gql`
  query EditBarcode($companyId: ID!, $filters: BarcodeFilters) {
    barcodes(companyId: $companyId, filters: $filters) {
      nodes {
        id
        barcodeNumber
      }
    }
  }
`
